import { render, staticRenderFns } from "./CompReservationSpaceBookingCard.vue?vue&type=template&id=b14079d8&scoped=true"
import script from "./CompReservationSpaceBookingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompReservationSpaceBookingCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompReservationSpaceBookingCard.vue?vue&type=style&index=0&id=b14079d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14079d8",
  null
  
)

export default component.exports